import React from 'react';
import { NavbarElementProps } from 'react-day-picker';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import useIsMobile from 'Hooks/Common/useIsMobile';

import Arrow from 'Assets/images/icons/angle-arrow.svg';

const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const NavbarElement = ({
  className,
  month,
  onPreviousClick,
  onNextClick,
}: NavbarElementProps) => {
  const currentMonth = `${monthNames[month.getMonth()]} ${month.getFullYear()}`;
  const isMobile = useIsMobile();
  return (
    <div className={className}>
      <span onClick={() => onPreviousClick()}>
        <ReactSVG className="DayPicker__nav DayPicker__nav--left" src={Arrow} />
      </span>
      <div className={classNames('DayPicker__nav-title', { mobile: isMobile })}>
        {currentMonth}
      </div>
      <span onClick={() => onNextClick()}>
        <ReactSVG className="DayPicker__nav" src={Arrow} />
      </span>
    </div>
  );
};
export default NavbarElement;
